export default __webpack_public_path__ + "64346b13acef016dbf654e77710a6084.woff";